import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import TextInput from "../../components/textInput";
import ButtonComponent from "../../components/button";
import ToastNotification from "../../components/toastNotification";
import { Typography, IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { logout, setUserData } from "../../redux/slices/userSlice";
import ActiveDirectoryIntegrationButton from "../../components/activeDirectoryIntegrationButton";
import { setAllowedRoutes } from "../../redux/slices/userSlice";
import { getAvailableRoutesByRole } from "../../services/apiService";

const schema = yup.object().shape({
  email: yup.string().email("Email inválido").required("El email es requerido"),
  password: yup.string().required("La contraseña es requerida")
});

/** Usuarios de prueba: email (o patrón), contraseña, rol para consultar permisos en BD. */
const EMAIL_LOGIN_USERS = [
  { email: "contabilidad@intelnova.co", password: "N4v4b!ll1n6", role: "Contabilidad", name: "Contabilidad" },
  { emailPattern: /^contador@/i, password: "N4v4b!ll1n6", role: "User", name: "Contador (User)" },
];

const getEmailLoginUser = (email, password) => {
  const user = EMAIL_LOGIN_USERS.find(
    (u) => (u.email && u.email === email) || (u.emailPattern && u.emailPattern.test(email)),
  );
  return user && user.password === password ? user : null;
};

const Login = () => {
  const [toastMessage, setToastMessage] = useState("");
  const [toastOpen, setToastOpen] = useState(false);
  const [toastSeverity, setToastSeverity] = useState("info");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { control, handleSubmit } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      email: "",
      password: ""
    }
  });
  useEffect(() => {
    dispatch(logout());
  }, [dispatch]);

  const handleFormSubmit = async (formData) => {
    const { email, password } = formData;
    const loginUser = getEmailLoginUser(email, password);

    if (!loginUser) {
      setToastSeverity("error");
      setToastMessage("Credenciales incorrectas. Por favor, intenta de nuevo.");
      setToastOpen(true);
      return;
    }

    let routes = [];
    try {
      const res = await getAvailableRoutesByRole(loginUser.role);
      routes = Array.isArray(res?.data) ? res.data : [];
    } catch (apiError) {
      console.warn("GetAvailableRoutesByRole no disponible:", apiError);
      setToastSeverity("error");
      setToastMessage("No se pudieron cargar los permisos. Verifica que la API esté disponible.");
      setToastOpen(true);
      return;
    }

    if (routes.length === 0) {
      setToastSeverity("error");
      setToastMessage("Tu rol no tiene pantallas asignadas. Contacta al administrador.");
      setToastOpen(true);
      return;
    }

    dispatch(
      setUserData({
        email: email,
        name: loginUser.name
      })
    );
    const userData = {
      name: loginUser.name,
      email: email
    };
    localStorage.setItem("allowedRoutes", JSON.stringify(routes));
    localStorage.setItem("userData", JSON.stringify(userData));
    dispatch(setAllowedRoutes(routes));
    setToastSeverity("success");
    setToastMessage("Inicio de sesión exitoso.");
    setToastOpen(true);

    setTimeout(() => {
      navigate(routes[0]);
    }, 1000);
  };

  return (

    <div className="login-container a-center j-cente">
      <Typography variant="h3" className="login-title">
        NovaBilling
      </Typography>
      <form onSubmit={handleSubmit(handleFormSubmit)} className="mt-15">
        <TextInput name="email" control={control} label="Email" />
        <div>
          <TextInput
            name="password"
            control={control}
            label="Contraseña"
            type={showPassword ? "text" : "password"}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label={
                    showPassword ? "hide the password" : "display the password"
                  }
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </div>
        <div className="vm-15 j-center">
          <ButtonComponent
            type="submit"
            variant="contained"
            backgroundColor="#1976d2"
            textColor="#fff"
          >
            Ingresar
          </ButtonComponent>
        </div>
        <div className="vm-15 j-center">
          <ActiveDirectoryIntegrationButton />
        </div>
      </form>

      <ToastNotification
        open={toastOpen}
        handleClose={() => setToastOpen(false)}
        message={toastMessage}
        severity={toastSeverity}
      />
    </div>
  );
};

export default Login;
